<template>
  <div class="search">
    <!-- navbar -->
    <Navbar showSearchButton v-on:search="changeParam"></Navbar>

    <div class="container">

      <PanelPokreni v-if="appState == 'round-in-progress'"/>

      <div class="score-list">
        <span class="pic icon-trophey"></span>
        <p class="name"> Pretraži korisnike </p>
        <div>
            <Loading :loadingState="loadingState">
                <template v-if="results && results.length > 0">
                    <ul>
                        <ListRezultataSingle v-for="(val, index) in results" v-bind:key="index" :value="val" :userPosition="index + 1" :isUserLiga="false"></ListRezultataSingle>
                    </ul>
                </template>
                <template v-if="results && results.length == 0">
                    <NoResults message="Nažalost nema rezultata za pretragu"></NoResults>
                </template>
                <template v-slot:error>
                    <ErrorMessageText></ErrorMessageText>
                </template>
            </Loading>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Loading from '../components/common/Loading'
import LoadingState from '../utils/loading/LoadingState'
import ErrorMessageText from '../components/common/error/ErrorMessageText'
import NoResults from '../components/common/error/NoResults'
import ListRezultataSingle from '../components/lista-rezultata/ListRezultataSingle'
import { ApplicationState } from '../application-state'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'search',
    data: function () {
        return {
            loadingState: LoadingState.LOADING,
            results: {}
        }
    },
    watch: {
        searchValue (after) {
            this.searchUsers()
        },
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.searchUsers()
            }
        }
    },
    computed: {
        searchValue () {
            return this.$route.params.value
        },
        appState () {
            return this.$store.state.appState
        }
    },
    mounted () {
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.searchUsers()
        }
    },
    methods: {
        validateSearch () {
            return this.searchValue && this.searchValue.length > 2
        },
        async searchUsers () {
            try {
                if (this.validateSearch()) {
                    this.loadingState = LoadingState.LOADING
                    this.results = await this.$db.metadata.searchUsers(this.searchValue)
                    this.loadingState = LoadingState.SUCCESS
                } else {
                    this.loadingState = LoadingState.ERROR
                }
            } catch (error) {
                this.loadingState = LoadingState.ERROR
            }
        },
        changeParam (value) {
            this.$router.replace(`/search/${value}`)
        }
    },
    components: {
        Navbar,
        Loading,
        ListRezultataSingle,
        ErrorMessageText,
        NoResults,
        PanelPokreni
    }
}
</script>

<style lang="scss" scoped>
  .score-list {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border-radius: 5px;
    padding: 54px 12px 9px;
    margin-top: 80px;

    .no-results {
        padding: 15px 0;
    }

    .pic {
        display: block;
        position: absolute;
        left: calc(50% - 40px);
        top: -30px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 5px solid #fff;
        background-color: #fff;
        background-position: 50%;
        background-size: cover;
    }

    .name {
        font-family: "axiforma";
        font-size: 16px;
        letter-spacing: .3px;
        color: #000;
        margin-bottom: 10px;
    }

    .select {
        display: block;
        width: 100%;
        appearance: none;
        outline: none;
        text-align: left;
        font-family: "axiforma";
        font-size: 16px;
        line-height: 22px;
        letter-spacing: .3px;
        color: #000;
        border: none;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 20px;
        padding-left: 4px;
        background: url(~@/assets/img/icons/icon-carrot.png) 98% 50% no-repeat;
        background-size: 6px;
        &.month-select {
            text-transform: capitalize;
            option {
                text-transform: capitalize;
            }
        }
    }

    ul {
        position: relative;
        margin-top: 44px;
    }
    /deep/ .loading-error {
        color: red;
        font-weight: bold;
    }
  }
  .panel-pokreni {
      margin-top: 80px;
  }
</style>
